import React, {Component} from 'react';
import Course from './Course'
import './Teaching.css';

class Teaching extends Component {

    constructor(props) {

        super(props);
        this.state = {
            teaching: undefined,
            attempts: 0,
        };

    }

    componentDidMount(){

        if(this.state.teaching === undefined)
            this.downloadTeaching();

    }

    render() {

        if(this.state.teaching === undefined)
            return <div></div>;

        var body = [];

        for(var year in this.state.teaching){

            var group = this.state.teaching[year];
            var courses = group.map((course, index)=>{
                return <Course key={course.year+index}data={course}/>
            });

            body.push(
                <div key={year} className="Group">
                    <div className="GroupName">{year}</div>
                    {courses}
                </div>);

        }

        return (
            <div className="Teaching">
                {body}
            </div>
        );

    }

    downloadTeaching(){

        var caller = this;

        return fetch(process.env.PUBLIC_URL +'/teaching.json')
            .then((response) => response.json())
            .then((responseJson) => {

                this.props.readyCallback(true);

                caller.setState({teaching: caller.sortTeaching(responseJson)});


            }).catch((error) => {

                console.error(error);

                if (caller.state.attempts < 3) {

                    caller.setState({
                        attempts: caller.state.attempts + 1
                    })

                    caller.downloadTeaching();

                }

                this.props.readyCallback(false, caller.state.attempts < 3);

            });

    }

    sortTeaching(teaching) {

        var teachingByYear = {};

        for (var key in teaching) {

            var year = teaching[key]['year'];

            var courseArray = teachingByYear[year];
            if(courseArray ===undefined){
                courseArray  = [];
                teachingByYear[year] = courseArray ;

            }

            courseArray.push(teaching[key]);

        }

        return teachingByYear;

    }

}

export default Teaching;



// WEBPACK FOOTER //
// ./src/Teaching.js